import styled from 'styled-components'

export const Wrapper = styled.div`
  width: 100%;
  height: fit-content;

  font-size: 18px;
  display: flex;
  flex-direction: column;
  gap: 20px;
`

export const BodyOverflowWrapper = styled.div`
  display: flex;
  flex: 1;
`

export const BodyWrapper = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  // Conditional Properties
  ${({ minWidth }) => minWidth && `min-width: ${minWidth}px;`}
`

export const HeaderFilterButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 100%;
  margin-bottom: -20px;
`

export const HeaderOptionsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 5px;
  width: 100%;
`
export const BodyChildrenWrapper = styled.div`
  height: 100%;
  width: 100%;
`
